import { render, staticRenderFns } from "./VerificSuccess.vue?vue&type=template&id=2155d658&scoped=true&"
import script from "./VerificSuccess.vue?vue&type=script&lang=js&"
export * from "./VerificSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2155d658",
  null
  
)

export default component.exports